import { Link } from 'react-router';
import { useGetPrograms, type Program } from '../api/useGetPrograms';
import { DataTable, type Column } from './DataTable';
import { ProgramStatusBadge } from './ProgramStatusBadge';
import { programStatus } from '../lib/programStatus';
import { formatDate } from '../lib/date';

const ALL_LIMIT = 200;
const SHOW = 8;

const isUpcomingOrLive = (program: Program) => {
  const status = programStatus(program);
  return status === 'Upcoming' || status === 'Live';
};

const columns: Column<Program>[] = [
  { key: 'name', header: 'Name', className: 'text-gray-900', cell: (p) => p.name },
  { key: 'organizer', header: 'Organizer', cell: (p) => p.merchant_name },
  { key: 'status', header: 'Status', cell: (p) => <ProgramStatusBadge program={p} /> },
  { key: 'starts', header: 'Start', className: 'text-gray-500', cell: (p) => formatDate(p.starts_at) },
  { key: 'ends', header: 'End', className: 'text-gray-500', cell: (p) => formatDate(p.ends_at) },
];

export const UpcomingPrograms = () => {
  const { data, isLoading, isError } = useGetPrograms({ page: 0, limit: ALL_LIMIT });

  const rows = (data?.payload?.programs ?? []).filter(isUpcomingOrLive).slice(0, SHOW);

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-900">Upcoming &amp; Live Programs</h2>
        <Link to="/programs" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">
          View all
        </Link>
      </div>
      <DataTable
        columns={columns}
        rows={rows}
        rowKey={(p) => p.uid}
        isLoading={isLoading}
        isError={isError}
        errorLabel="Failed to load programs."
        emptyLabel="No upcoming or active programs."
      />
    </section>
  );
};
